import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8536 9.64487C18.0488 9.84014 18.0488 10.1567 17.8536 10.352L15.0251 13.1804C14.8299 13.3757 14.5133 13.3757 14.318 13.1804C14.1228 12.9851 14.1228 12.6686 14.318 12.4733L16.2929 10.4984L7.5 10.4984C7.22386 10.4984 7 10.2746 7 9.99843C7 9.72229 7.22386 9.49843 7.5 9.49843L16.2929 9.49843L14.318 7.52355C14.1228 7.32829 14.1228 7.01171 14.318 6.81645C14.5133 6.62118 14.8299 6.62118 15.0251 6.81645L17.8536 9.64487ZM10.5 4C10.7761 4 11 4.22386 11 4.5L11 7C11 7.27614 11.2239 7.5 11.5 7.5C11.7761 7.5 12 7.27614 12 7L12 4.5C12 3.67157 11.3284 3 10.5 3L4.5 3C3.67157 3 3 3.67157 3 4.5L3 15.5C3 16.3284 3.67157 17 4.5 17L10.5 17C11.3284 17 12 16.3284 12 15.5L12 13C12 12.7239 11.7761 12.5 11.5 12.5C11.2239 12.5 11 12.7239 11 13L11 15.5C11 15.7761 10.7761 16 10.5 16L4.5 16C4.22386 16 4 15.7761 4 15.5L4 4.5C4 4.22386 4.22386 4 4.5 4L10.5 4Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9939 4.42125C13.9256 3.62983 13.289 3 12.5 3H4.5L4.36243 3.00644C3.59278 3.07892 3 3.75368 3 4.5625V19.4375L3.00607 19.5787C3.07437 20.3702 3.71098 21 4.5 21H12.5L12.6376 20.9936C13.4072 20.9211 14 20.2463 14 19.4375V17.393L13.9919 17.3032C13.9496 17.0699 13.7455 16.893 13.5 16.893C13.2239 16.893 13 17.1169 13 17.393V19.4375L12.9933 19.5303C12.9534 19.8013 12.7422 20 12.5 20H4.5L4.4206 19.9928C4.187 19.9502 4 19.723 4 19.4375V4.5625L4.00673 4.46967C4.04656 4.19869 4.25778 4 4.5 4H12.5L12.5794 4.00719C12.813 4.04978 13 4.27701 13 4.5625V6.65069L13.0081 6.74057C13.0504 6.97382 13.2545 7.15069 13.5 7.15069C13.7761 7.15069 14 6.92683 14 6.65069V4.5625L13.9939 4.42125ZM15.846 8.04167C15.711 7.8468 15.7302 7.57737 15.9038 7.40381C16.0991 7.20854 16.4157 7.20854 16.6109 7.40381L20.8654 11.6587L20.9114 11.7157L20.9622 11.809L20.9832 11.8711L20.9953 11.9366L20.9946 11.9264C20.9956 11.933 20.9964 11.9396 20.9971 11.9462L20.9972 11.9465L20.9972 11.9469C20.9987 11.9607 20.9995 11.9746 20.9999 11.9885L20.9997 11.9942L21 12L20.9997 11.9953L20.9982 12.0423L20.9945 12.0742L20.977 12.1502L20.946 12.2262L20.9205 12.2707C20.9016 12.3001 20.8792 12.3279 20.8536 12.3536L16.6109 16.5962L16.5417 16.654C16.3468 16.789 16.0774 16.7698 15.9038 16.5962L15.846 16.5269C15.711 16.3321 15.7302 16.0627 15.9038 15.8891L19.295 12.4994L8.5 12.5C8.22386 12.5 8 12.2761 8 12C8 11.7239 8.22386 11.5 8.5 11.5L19.295 11.4994L15.9038 8.11091L15.846 8.04167Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'logout');
export default IconComponent;
